import React, { Component } from 'react';
import striptags from 'striptags';
import cx from 'classnames';
import { Button, Modal } from 'antd';

import SxCheckbox from './sxCheckbox';
import SxIcon from './sxIcon';

import {
  NAVIGATION_ELEMENT_IDS,
  getElements,
  removeFromTabOrder,
  addToTabOrder,
  focusNextPageButton,
} from '../utils/tabOrder.utils';
import { ENTER_KEY_CODE } from '../types/keyCodes';
import { isExportToWord } from '../utils/printPreview.utils';

import './welcomePage.scss';

const BG_TAB_ELEMENT_IDS = {
  ...NAVIGATION_ELEMENT_IDS,
  AGREE_CHECKBOX: 'termsAndConditionsCheckboxId',
  TERMS_BUTTON: 'openModalButtonId',
};

class WelcomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      agree: false,
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.onAgreeChange = this.onAgreeChange.bind(this);
    this.handleAgree = this.handleAgree.bind(this);
    this.handleDisagree = this.handleDisagree.bind(this);
    this.renderWelcomePageForDocx = this.renderWelcomePageForDocx.bind(this);
  }

  componentDidMount() {
    this.backgroundTabElements = getElements(Object.values(BG_TAB_ELEMENT_IDS));
  }

  handleOpen() {
    removeFromTabOrder(this.backgroundTabElements);
    this.setState({ open: true });
  }

  handleClose() {
    addToTabOrder(this.backgroundTabElements);
    this.setState({ open: false });
  }

  handleKeyDown(e) {
    if (e.keyCode === ENTER_KEY_CODE) {
      this.handleOpen();
    }
  }

  onAgreeChange() {
    addToTabOrder(this.backgroundTabElements);
    this.setState({ agree: !this.state.agree });
    this.props.agreeChange(!this.state.agree);
  }

  handleAgree() {
    addToTabOrder(this.backgroundTabElements);
    focusNextPageButton();
    this.setState({ open: false, agree: true });
    this.props.agreeChange(true);
  }

  handleDisagree() {
    addToTabOrder(this.backgroundTabElements);
    this.setState({ open: false, agree: false });
    this.props.agreeChange(false);
  }

  renderWelcomeText(hasWelcomeText) {
    if (!hasWelcomeText) {
      return null;
    }
    const { welcomeText } = this.props;
    return (
      <div className="welcomeText ql-editor ql-editor-to-show" dangerouslySetInnerHTML={{ __html: welcomeText }} />
    );
  }

  renderTermsAndConditions() {
    const { termsAndConditions, uiTags = {} } = this.props;
    if (!termsAndConditions || striptags(termsAndConditions).trim() === '') {
      return null;
    }
    return (
      <div className="termsAndConditionsContainer welcomePageTerms">
        <p className="termsAndConditionsElement">{uiTags.termsAndConditionsModalTitle}</p>
        <div className="termsAndConditionsElement agreeCheckbox">
          <SxCheckbox
            id={BG_TAB_ELEMENT_IDS.AGREE_CHECKBOX}
            label={uiTags.termsAndConditionsLabel}
            checked={this.state.agree}
            onChange={this.onAgreeChange}
          />
          <span
            id={BG_TAB_ELEMENT_IDS.TERMS_BUTTON}
            className="termAndConditionsLink"
            tabIndex="0"
            onClick={this.handleOpen}
            onKeyDown={this.handleKeyDown}
          >
            <SxIcon noFloat name="sx-external" />
          </span>
        </div>
      </div>
    );
  }

  renderModal() {
    const { termsAndConditions, uiTags = {} } = this.props;
    return (
      <Modal
        title={uiTags.termsAndConditionsModalTitle}
        className="termsAndConditionsModal"
        visible={this.state.open}
        onCancel={this.handleClose}
        closeIcon={<SxIcon className="closeIcon" name="sx-cross" />}
        footer={
          <>
            <Button tabIndex="0" type="link" onClick={this.handleDisagree} className="cancelButton">
              {uiTags.disagree}
            </Button>
            <Button tabIndex="0" type="primary" onClick={this.handleAgree}>
              <SxIcon name="sx-check" />
              {uiTags.agree}
            </Button>
          </>
        }
      >
        <div
          className="termsAndConditions ql-editor ql-editor-to-show"
          dangerouslySetInnerHTML={{ __html: termsAndConditions }}
        />
      </Modal>
    );
  }

  renderWelcomePageForDocx() {
    const { welcomeText, termsAndConditions } = this.props;
    return (
      <div>
        {welcomeText}
        <br />
        <br />
        {termsAndConditions}
      </div>
    );
  }

  render() {
    const { welcomeText } = this.props;
    const hasWelcomeText = welcomeText && striptags(welcomeText).trim() !== '';
    const welcomePageClassName = cx('welcomePage', { withoutWelcomeText: hasWelcomeText });
    if (isExportToWord()) {
      return this.renderWelcomePageForDocx();
    }
    return (
      <div className={welcomePageClassName}>
        {this.renderWelcomeText(hasWelcomeText)}
        {this.renderTermsAndConditions()}
        {this.renderModal()}
      </div>
    );
  }
}

export default WelcomePage;
